var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("@/assets/logo.png"),"alt":"HD Lift Equipment"}})
}
var staticRenderFns = []

export { render, staticRenderFns }